<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import needsService from "@/services/needs.service";
import {ref, onMounted, provide, computed} from "vue";
import needsStartupsService from "@/services/needs-startups.service";
import SearchMatching from "@/views/needs/need/SearchMatching.vue";
import Solutions from "@/views/needs/need/Solutions.vue";
import NewMatches from "@/views/needs/need/NewMatches.vue";
import VClamp from "vue-clamp";

const route = useRoute();
const need = ref(null);
const startups = ref([]);
const searchMatching = ref(null);

const solutions = computed(() => startups.value.filter(startup => startup.status === 'liked'));

onMounted(() => {
    getInfo();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);
    need.value = data;

    if (!need.value.start_search) {
        getStartups();
    }
}

async function getStartups() {
    const {data} = await needsStartupsService.getStartups(route.params.id);
    startups.value = data;
}

async function getNewAiMatches() {
    await needsStartupsService.getNewAiMatches(route.params.id);
    await getStartups();
}

async function removeMatching() {
    await needsStartupsService.removeStartupsMatchStatus(route.params.id);
    getInfo();
}

provide('need', need);
provide('needId', route.params.id);
provide('getInfo', getInfo);
provide('solutions', solutions);
</script>

<template>
    <div v-if="need" class="need-page">
        <!-- <div class="card-needs">
            <div class="card-needs__content card-needs__content--columns">
                <div>
                </div>
            </div>
        </div> -->

        <div class="need-page__content">
            <aside class="need-page__aside">
                <h4 class="heading4">{{need.name}}</h4>

                <p>
                    <v-clamp autoresize :max-lines="4" class="activity-list__content__text" style="white-space: pre-wrap">
                        {{need.description}}

                        <template #after="{ toggle, expanded, clamped }">
                            <a v-if="expanded" class="link-normal" @click="toggle">less</a>
                            <a v-if="clamped" class="link-normal" @click="toggle">more</a>
                        </template>
                    </v-clamp>
                </p>

                <div class="mb-4">
                    <a href="#" class="link link-edit-light">Refine</a>
                </div>

                <div class="card-needs__sidebar mb-4">
                    <ul class="list-plan">
                        <li class="list-plan__done">Add AI-suggested solutions</li>
                        <li class="list-plan__done">Add ecosystem recommendations</li>
                        <li>Rate all your solutions</li>
                        <li>Escalate need to innovation team</li>
                    </ul>

                    <a href="#" class="btn-xl btn-xl-export mb-3">Escalate Need</a>

                    <p class="mb-0"><b>Escalate</b> to send this need and your assessed solutions to your innovation team for further review</p>
                </div>

                

                <!--  -->
                <div class="card-headline">
                    <header class="card-headline__header">Summary Report</header>

                    <div class="card-headline__inner">
                        <img src="https://sp-images-prod.s3.amazonaws.com/knowledge-base-images/image%286%29.png" alt="" />
                    </div>
                    <footer class="card-headline__footer">
                        <a href="#" class="link link--view d-flex justify-content-end">View</a>
                    </footer>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Activity</header>

                    <div class="card-headline__content">
                        <ul class="need-list-activity">
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                            <li><span>Removed <a href="#">Gamma Core</a></span></li>
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                        </ul>

                        <div class="text-center">
                            <a href="#" class="link">Load More</a>
                        </div>
                    </div>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Settings</header>

                    <div class="card-headline__content">


                        <div class="content-switcher content-switcher--tertiary">
                            AI solution recommendations
                            <div class="content-switcher__slider">
                                <input type="checkbox" id="hidden-for-startups-switcher__slider">
                                <label for="hidden-for-startups-switcher__slider"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <SearchMatching
                v-if="need?.need_matching_search"
                :need-id="route.params.id"
                ref="searchMatching"
                @done="getInfo"
            />

            <div v-else class="need-page__inner">
                <div class="card-needs mb-5">
                    <NewMatches/>
                </div>

                <div v-if="solutions.length" class="card-needs">
                    <Solutions/>
                </div>
            </div>
        </div>

        <a class="link" @click="getNewAiMatches">Get New Matches</a>
        <br>
        <a class="link" @click="removeMatching">Remove matching</a>
    </div>
</template>

<style scoped>

</style>
